import { createStore } from "vuex";

export const dataReport = createStore({
  state: () => ({
    activeTab: "recent",

    visitClients: [],
    reports: [],
    layouts: [],

    selectedVisitClient: null,
    selectedReport: null,
    selectedLayout: null,

    visitClientsViewMode: "table",
    reportsViewMode: "table",

    filters: {
      visitClientsSearch: "",
      reportsSearch: "",
      layoutsSearch: "",
      status: "all",
      layoutsStatus: "all",
    },

    loading: {
      visitClients: false,
      reports: false,
      layouts: false,
    },
  }),

  mutations: {
    setActiveTab(state, tab) {
      state.activeTab = tab;
    },

    setVisitClients(state, clients) {
      state.visitClients = Array.isArray(clients) ? clients : [];
    },

    addVisitClient(state, client) {
      state.visitClients.unshift(client);
    },

    updateVisitClient(state, updatedClient) {
      const index = state.visitClients.findIndex(
        (client) => client.id === updatedClient.id
      );

      if (index !== -1) {
        state.visitClients.splice(index, 1, {
          ...state.visitClients[index],
          ...updatedClient,
        });
      }
    },

    disableVisitClient(state, clientId) {
      const index = state.visitClients.findIndex(
        (client) => client.id === clientId
      );

      if (index !== -1) {
        state.visitClients[index].is_active = false;
      }
    },

    setSelectedVisitClient(state, client) {
      state.selectedVisitClient = client;
    },

    setVisitClientsViewMode(state, mode) {
      state.visitClientsViewMode = mode;
    },

    setVisitClientsSearch(state, search) {
      state.filters.visitClientsSearch = search;
    },

    setVisitClientsLoading(state, value) {
      state.loading.visitClients = value;
    },

    setReports(state, reports) {
      state.reports = Array.isArray(reports) ? reports : [];
    },

    setLayouts(state, layouts) {
      state.layouts = Array.isArray(layouts) ? layouts : [];
    },

    reset(state) {
      state.activeTab = "recent";

      state.visitClients = [];
      state.reports = [];
      state.layouts = [];

      state.selectedVisitClient = null;
      state.selectedReport = null;
      state.selectedLayout = null;

      state.visitClientsViewMode = "table";

      state.filters.visitClientsSearch = "";
      state.filters.reportsSearch = "";
      state.filters.layoutsSearch = "";
      state.filters.status = "";

      state.loading.visitClients = false;
      state.loading.reports = false;
      state.loading.layouts = false;
    },
    enableVisitClient(state, clientId) {
      const index = state.visitClients.findIndex(
        (client) => client.id === clientId
      );

      if (index !== -1) {
        state.visitClients[index].is_active = true;
      }
    },

    addReport(state, report) {
      state.reports.unshift(report);
    },

    updateReport(state, updatedReport) {
      const index = state.reports.findIndex(
        (report) => report.id === updatedReport.id
      );

      if (index !== -1) {
        state.reports.splice(index, 1, {
          ...state.reports[index],
          ...updatedReport,
        });
      }
    },

    setSelectedReport(state, report) {
      state.selectedReport = report;
    },

    setReportsSearch(state, search) {
      state.filters.reportsSearch = search;
    },

    setReportsStatus(state, status) {
      state.filters.status = status;
    },

    setReportsLoading(state, value) {
      state.loading.reports = value;
    },

    setReportsViewMode(state, mode) {
      state.reportsViewMode = mode;
    },

    setLayouts(state, layouts) {
      state.layouts = Array.isArray(layouts) ? layouts : [];
    },

    addLayout(state, layout) {
      state.layouts.unshift(layout);
    },

    updateLayout(state, updatedLayout) {
      const index = state.layouts.findIndex(
        (layout) => layout.id === updatedLayout.id
      );

      if (index !== -1) {
        state.layouts.splice(index, 1, {
          ...state.layouts[index],
          ...updatedLayout,
        });
      }
    },

    setSelectedLayout(state, layout) {
      state.selectedLayout = layout;
    },

    setLayoutsSearch(state, search) {
      state.filters.layoutsSearch = search;
    },

    setLayoutsStatus(state, status) {
      state.filters.layoutsStatus = status;
    },

    setLayoutsViewMode(state, mode) {
      state.layoutsViewMode = mode;
    },

    setLayoutsLoading(state, value) {
      state.loading.layouts = value;
    },
  },
});